import APITemplate from '@/api/APITemplate'

const url = '/api/configs'

const template = APITemplate(url)
export default {
  ...template
}
